/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import React, { Component } from 'react';
import classnames from 'classnames';
// import _throttle from 'lodash/throttle'

// TODO: this Component can be optimized in many places (hooks, refs, remove jsxIf, ErrorBoundaries, move some stylistic elements into CSS, etc), use data- attributes (heading, text, storage_var), refactor listeners, consolidate open/close toast functionality, proper tag markup, css is overcomplicated

export default class NMExpandableToast extends Component {
  constructor(props) {
    super(props);
    this.state = {
      popupIsActive: false,
      popupExpanded: false,
      mmBreakpoint: this.mmCheck(),
    };

    // bind functions
    this.toggleContent = this.toggleContent.bind(this);
    this.openToast = this.openToast.bind(this);
    this.hideToast = this.hideToast.bind(this);
    this.collapsePopup = this.collapsePopup.bind(this);

    // bind listeners
    // this.resizeListener = _throttle(this.resizeListener.bind(this), 200) // TODO: listeners need to be constructed differently
    // this.keyDownListener = _throttle(this.keyDownListener.bind(this), 100) // TODO: listeners need to be constructed differently
    // this.clickListener = _throttle(this.clickListener.bind(this), 100) // TODO: listeners need to be constructed differently

    // component refs
    this.toastContainer = React.createRef();
    this.toastAccordion = React.createRef();
    this.textBlock = React.createRef();
    this.popupBox = React.createRef();
    this.toastToggleBtn = React.createRef();
  }

  mmCheck = () => window.matchMedia('(min-width: 769px)').matches

  toggleContent = (e) => {
    e.preventDefault();
    // Get computed height of hidden text content and use it to set the height of the accordion when it expands
    this.setState({ popupExpanded: !this.state.popupExpanded });
    this.openToast();
  };

  openToast = () => {
    // console.log('openToast', this.state.popupExpanded, this.toastAccordion.current)
    // if(this.state.popupExpanded) {
    this.toastAccordion.current.style.height = `${this.textBlock.current.offsetHeight + 60}px`; // text height + close button height
    this.toastContainer.current.style.height = `${this.textBlock.current.offsetHeight + 60}px`; // text height + close button height
    // } else {
    //   this.collapsePopup()
    // }
  }

  hideToast = () => {
    this.setState({ popupIsActive: false });
    // Set data in localStorage so the banner stays hidden for this user
    try {
      localStorage.setItem(this.props.storage_var, false);
    } catch (error) {
      console.error(`localStorage setItem failed with error ${error}`);
      // newRelicJSError(error);
    }
  }

  collapsePopup = () => {
    this.setState({ popupExpanded: false });
    this.toastAccordion.current.style.height = '0';
    this.toastContainer.current.style.height = this.mmCheck() ? '60px' : '50px';
  }

  // keyDownListener (e) {
  //   const escapeKeyCode = 27

  //   switch (e.keyCode) {
  //     case escapeKeyCode:
  //       const target = e.target || e.srcElement;
  //       // Hide popup if user is focused in or on the element and hits escape
  //       if (this.popupBox.contains(target)) {
  //         if (e.keyCode === 27) {
  //           this.hideToast();
  //         }
  //       }
  //       break
  //     default:
  //       break
  //   }
  // }

  // resizeListener () {
  //   let enableListener = true;

  //   if (!enableListener) return;
  //   enableListener = false;
  //   this.collapsePopup();
  //   setTimeout(() => {enableListener = true}, 300);
  // }

  // clickListener () {
  // }

  componentWillMount() {
    // Get data from localStorage to see if the user chose to hide the announcement component
    try {
      if (localStorage.getItem(this.props.storage_var) === 'false') {
        this.setState({ popupIsActive: false });
      } else if (localStorage.getItem(this.props.storage_var) === null) { // if prop is not set, then show expandable toast
        this.setState({ popupIsActive: true });
      }
    } catch (error) {
      console.error(`localStorage getItem failed with error ${error}`);
      // newRelicJSError(error);
    }
  }

  componentDidMount = () => {
    // only add event listeners is popup displays
    // TODO: all of these listeners can be built better (listener should call a function)
    if (this.state.popupIsActive) {
      // window.addEventListener('click', this.clickListener, true)
      window.addEventListener('click', (e) => {
        const target = e.target;
        if (!this.popupBox.current.contains(target) && this.popupBox.current !== target) {
          // Collapse popup is the user clicks outside on the popup
          this.collapsePopup();
        } else if (!this.state.popupExpanded) {
          // Collapse popup is the user clicks heading button
          if (!(this.toastToggleBtn.current !== target && !this.toastToggleBtn.current.contains(target))) {
            this.collapsePopup(); // TODO: This logic is not efficient, setting popupExpanded
          }
        }
      });

      // window.addEventListener('keydown', this.keyDownListener, true)
      window.addEventListener('keydown', (e) => {
        const target = e.target || e.srcElement;
        // Hide popup if user is focused in or on the element and hits escape
        if (this.popupBox.current.contains(target)) {
          if (e.keyCode === 27) {
            this.hideToast();
          }
        }
      });

      // if (window) {
      //   window.addEventListener('resize', this.resizeListener)
      // }
      let enableListener = true;
      window.addEventListener('resize', () => {
        if (!enableListener) return;
        enableListener = false;
        this.collapsePopup();
        setTimeout(() => { enableListener = true; }, 300);
      });
    }
  }

  componentWillUnmount() {
    // remove listeners
    // window.removeEventListener('keydown', this.keyDownListener, true)
    // window.removeEventListener('resize', this.resizeListener, true)
    // window.removeEventListener('click', this.clickListener)

    // TODO: all of these listeners can be built better
    window.removeEventListener('click', (e) => {
      const target = e.target || e.srcElement;
      // Collapse popup is the user clicks outside on the popup
      if (!this.popupBox.contains(target) && this.popupBox !== target) {
        this.collapsePopup();
      }
    });

    window.removeEventListener('keydown', (e) => {
      const target = e.target || e.srcElement;
      // Hide popup if user is focused in or on the element and hits escape
      if (this.popupBox.contains(target)) {
        if (e.keyCode === 27) {
          this.hideToast();
        }
      }
    });

    window.removeEventListener('resize', () => {
      if (!enableListener) return;
      enableListener = false;
      this.collapsePopup();
      setTimeout(() => { enableListener = true; }, 300);
    });
  }

  render() {
    const { heading, text } = this.props;
    const { popupIsActive, popupExpanded } = this.state;
    // If the text props are passed in as an array, map it to the component.
    // If it's a single string, just display the text
    try {
      const textArray = JSON.parse(text);
      this.textEntries = textArray.map((item, index) => <span key={index} className="nm-expandable-toast__text-block">{item}</span>);
    } catch (error) {
      this.textEntries = <span className="nm-expandable-toast__text-block">{text}</span>;
    }

    return (
      <div className={`nm-expandable-toast
        ${!popupIsActive
        ? 'nm-expandable-toast--hidden'
        : ''}`}
        aria-hidden={!popupIsActive}>
        <button
          id='nm-expandable-toast-close-button'
          className="nm-expandable-toast__close-button"
          aria-label='Close notification popup'
          onClick={() => this.hideToast()}>&#10005;</button>
        <div
          className="nm-expandable-toast__box"
          ref={this.popupBox}
          aria-modal='true'
          role='dialog'
        >
          <div className="nm-expandable-toast__content-container" ref={this.toastContainer}>
            <button
              id='nm-expandable-toast-toggle-content-button'
              className="nm-expandable-toast__toggle-button"
              ref={this.toastToggleBtn}
              onClick={e => this.toggleContent(e)}>
              <span className={classnames('nm-expandable-toast__heading', { 'nm-expandable-toast__heading--is-expanded': popupExpanded })}>
                <span className="nm-expandable-toast__heading-text">
                  {heading}
                </span>
                <span
                  className="nm-expandable-toast__toggle-button-icon-container"
                  aria-label={
                  !popupExpanded
                    ? 'Show more information'
                    : 'Hide additional information'
}>
                  <span className={classnames('nm-expandable-toast__toggle-button-icon', { 'nm-expandable-toast__toggle-button-icon--inverted': popupExpanded })} aria-hidden='true'>
                  </span>
                </span>
              </span>
            </button>
            <div
              className='nm-expandable-toast__toggle-content'
              aria-hidden={!popupExpanded}
              ref={this.toastAccordion}
            >
              <div ref={this.textBlock}>
                <p className="nm-expandable-toast__text">{this.textEntries}</p>
                <button
                  id='nm-expandable-toast-text-close-button'
                  className="nm-expandable-toast__text-close-button"
                  aria-label='Close notification popup'
                  onClick={() => this.hideToast()}>
                  close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
